export const CURSO_CONFIG = {
    
    TEXTO_AREA_DEPOIMENTOS: 'Se é palavra de confiança que você quer, então ouça a voz da experiência! Conheça a Souza Marques do ponto de vista de nossos alunos e egressos! Todos os depoimentos são prestados voluntariamente.',
    TITULO_GALERIA_FOTOS: 'Laboratórios e Infraestrutura',
}